export { default as verifyIfEveryInArray } from './verify-if-every-in-array';
